import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangLtIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "b",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 18,
			height: 18,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.436 9A8.439 8.439 0 1 1 .558 9a8.439 8.439 0 0 1 16.878 0Z",
				fill: "#fff"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#b)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M.563.563h16.875v6.68H.563V.562Z",
					fill: "#A63948"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M.563 7.242h16.875v3.516H.563V7.242Z",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M.563 10.758h16.875v6.68H.563v-6.68Z",
					fill: "#A63948"
				})
			]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangLtIconmin);
export { ForwardRef as ReactComponent };
